// extracted by mini-css-extract-plugin
export default {"addToCollection":"Bu-z"};